module.exports = __webpack_public_path__ + "img/img-loading.56e44c18.gif";